export enum CeremonyTypes {
  CATOLIC = '1',
  CIVIL = '7',
  OTHER = '18'
}
